define(
    'viewmodels/secured/explorer/navigation/libraries/FolderActions',[
        "viewmodels/controller",
        "providers/dataprovider",        
        "services/service.documents",
        "services/service.dialog",
        "viewmodels/secured/explorer/details/documentClipboard",
        "viewmodels/secured/explorer/navigation/libraries/accessFolder"
    ], 
    function (shell, dataProvider, documentsService, dialogService, clipboard, accessControlShow) {

        FolderActions.prototype.permissionsEnum =
        {
            none: 0,
            rename: 1,
            add: 2,
            remove: 4,
            addDocument: 8,
            accessControl: 16,
            share: 32
        };

        function FolderActions(ctx, accessControlShow) {
            var self = this;            
        
            self.treeNode = {};
            self.folderId = null;
            //self.showMenu = ko.observable(false).extend({ notify: 'always' });
            self.errors = ko.observableArray();
            self.permissions = ko.observable(self.permissionsEnum.none);

            //self.showMenu.subscribe(function (show) {
            //    self.permissions(self.permissionsEnum.none);
            //});

            self.clearErrors = function() {
                self.errors([]);
            };

            self.add = ko.asyncCommand({
                canExecute: function () {
                   return (self.permissions() & self.permissionsEnum.add);
                },
                execute: function (menuItem, complete) {
                    self.treeNode.add(function (callbacks) {
                        var cb = callbacks.data;                        
                    
                        dataProvider
                        .folders
                        .addFolderAndGet(cb.id, cb.name)
                        .done(function (d) {
                            var data = mapFolder(d);

                            var node = {
                                parentId: cb.id, id: d.folderId, text: cb.name, docCount: 0, data: data, hasChildren: false, expanded: false
                            };                            
                            
                            callbacks.success(node);

                            var f = ctx.findFolder({ folderId: cb.id, libraryId: data.libraryId });
                            if (f) f.folders.push(data);

                            setTimeout(function () {
                                self.treeNode.select(node);
                            }, 100);
                        })
                        .fail(function (e) {                            
                            //e.stopPropagation = true;
                            callbacks.fail();
                            console.warn(e);
                        });

                    });
                }
            });

            self.rename = ko.asyncCommand({
                canExecute: function () {
                    return (self.permissions() & self.permissionsEnum.rename);
                },
                execute: function (menuItem, complete) {
                    self.treeNode.rename(function (callbacks) {
                        var cb = callbacks.data;

                        dataProvider
                        .folders
                        .renameFolder(cb.id, cb.name)
                        .done(function () {
                            callbacks.success(ko.isObservable(cb.name) ? ko.observable(cb.name()) : ko.observable(cb.name));
                            
                            var f = ctx.findFolder({ folderId: cb.d.data.folderId, libraryId: cb.d.data.libraryId });
                            if(f) f.name(cb.name);
                        })
                        .fail(function (e) {                            
                            //e.stopPropagation = true;
                            //self.folderActions.errors(e.error);
                            callbacks.fail();
                            console.warn(e);
                        });
                    });
                }
            });

            self.remove = ko.asyncCommand({
                canExecute: function () {
                   return (self.permissions() & self.permissionsEnum.remove);
                },
                execute: function (menuItem, complete) {
                    self.treeNode.remove(function (callbacks) {
                        var cb = callbacks.data;
                        
                        dataProvider.documents
                        .getDeletedDocumentsByFolderId(cb.id)
                        .done(function (data) {
                            var d = _.filter(data.data, function (itm) { return itm != null && itm.documentId != null; });
                            if (d.length > 0) {
                                d = _.map(d, function (itm) { return { documentId: itm.documentId }; });
                                var promise = dialogService.showDialog("modals/secured/explorer/navigation/folders/PurgeFolderModal");

                                promise.then(function (dialogResult) {
                                    if (dialogResult.purge) {
                                        dataProvider.documents.actions
                                        .purgedeletedDocuments(d)
                                        .done(function (d) {

                                            dataProvider
                                            .folders
                                            .deleteFolder(cb.id)
                                            .done(function () {
                                                callbacks.success();

                                                ctx.removeFolder({ folderId: cb.id, libraryId: cb.d.data.libraryId, parentId: cb.d.data.parentId });
                                            })
                                            .fail(function (e) {
                                                callbacks.fail();

                                                complete();

                                                console.error(e);
                                            });

                                        })
                                        .fail(function (e) {
                                            callbacks.fail();

                                            complete();

                                            console.error(e);
                                        });
                                    }
                                });
                            } else {
                                dataProvider
                                .folders
                                .deleteFolder(cb.id)
                                .done(function () {
                                    callbacks.success();

                                    ctx.removeFolder({ folderId: cb.id, libraryId: cb.d.data.libraryId, parentId: cb.d.data.parentId });
                                })
                                .fail(function (e) {
                                    callbacks.fail();

                                    complete();

                                    console.error(e);
                                });
                            }
                        })
                        .fail(function (e) {
                            callbacks.fail();

                            complete();

                            console.error(e);
                        });

                    });
                }
            });

            self.copyDocuments = ko.asyncCommand({
                canExecute: function () {
                    return clipboard.canCopy();
                },
                execute: function (menuItem, complete) {                    
                    var documents = clipboard.paste();
                    var promise = dialogService.showDialog("modals/secured/explorer/navigation/folders/CopyDocumentsModal", [documents.length]);
                    
                    promise.then(function (dialogResult) {
                        if (dialogResult.copy) {
                            shell.isBusy(true, "Processing", 10);

                            documentsService.actions
                            .copyDocuments(clipboard.toDocumentLocationList(documents), self.folderId)
                            .done(function (result) {
                            })
                            .fail(function (e) {
                                console.error(e);

                                self.errors(e.error);                                
                            })
                            .always(function (result) {
                                ctx.onReloadFolders({ _updateNode: { docCount: ctx.current.folder.docCount + documents.length, text: ctx.current.folder.name() } });

                                shell.isBusy(false);
                                complete();
                            });
                        } else {
                            complete();
                        }
                    });
                }
            });
            self.copyDocuments.visible = function () {
                return true;
            };

            self.moveDocuments = ko.asyncCommand({
                canExecute: function () {
                    return clipboard.canMove();
                },
                execute: function (menuItem, complete) {                    
                    var documents = clipboard.paste();
                
                    if (documents[0].folderId !== self.folderId) {
                        var promise = dialogService.showDialog("modals/secured/explorer/navigation/folders/MoveDocumentsModal", [documents.length]);

                        promise.then(function (dialogResult) {
                            if (dialogResult.move) {
                                shell.isBusy(true, "Processing", 10);

                                documentsService.actions
                                .moveDocuments(clipboard.toDocumentLocationList(documents), self.folderId)
                                .done(function (result) {
                                    var c1 = ctx.pfolder.docCount - documents.length, n1 = ctx.pfolder.name(), f1 = ctx.pfolder.folderId;
                                    var c2 = ctx.current.folder.docCount + documents.length, n2 = ctx.current.folder.name();

                                    if (ctx.pfolder.libraryId != ctx.current.library.libraryId) {
                                        ctx.pendingRefresh[ctx.pfolder.libraryId] = { folderId: f1 };
                                    }

                                    ctx.onReloadFolders({ isUpdateNodeOnly: true, folderId: f1, _updateNode: { docCount: c1, text: n1 } });
                                    ctx.onReloadFolders({ _updateNode: { docCount: c2, text: n2 } });

                                    ctx.pfolder = null;
                                })
                                .fail(function (e) {
                                    console.error(e);

                                    self.errors(e.error);                                    
                                })
                                .always(function () {
                                    shell.isBusy(false);

                                    complete();
                                });
                            } else {
                                complete();
                            }
                        });
                    }
                }
            });
            self.moveDocuments.visible = function () {
                return true;
            };

            self.showAllDocuments = ko.asyncCommand({
                canExecute: function () {
                    return true;
                },
                execute: function (menuItem, complete) {
                    self.showAllDocuments.isSelected(!self.showAllDocuments.isSelected());

                    if(!self.showAllDocuments.isSelected())
                        ctx.onNavFolder({ folder: ctx.current.folder, documentId: null });
                    else
                        ctx.onNavFolderShowAll({ libraryId: ctx.current.library.libraryId, folderId: self.folderId });

                    complete();
                }
            });
            self.showAllDocuments.visible = function () {
                return true;
            };
            self.showAllDocuments.isSelected = ko.observable(false);

            self.accessControlCommand = ko.asyncCommand({
                canExecute: function () {                
                    return (self.permissions() & self.permissionsEnum.accessControl);
                },
                execute: function (menuItem, complete) {
                    accessControlShow(self.folderId);
                }
            });
            self.accessControlCommand.visible = function () {
                return true;
            };

            self.showDeletedCommand = ko.asyncCommand({
                canExecute: function () {
                    //return (self.permissions() & self.permissionsEnum.showDeleted);
                    return true;
                },
                execute: function (menuItem, complete) {
                    if (ctx.current.folder) {
                        ctx.onNavFolderShowDeleted({ folder: ctx.current.folder, libraryId: ctx.current.library.libraryId, folderId: self.folderId });

                        if (ctx.current.folder.folderId != self.folderId) {
                            console.error("folderId not equal");
                        }
                    }

                    complete();
                }
            });
            self.showDeletedCommand.visible = function () {
                return true;
            };
        }        

        return FolderActions;

        //mapping also in explorer Library.js
        function mapFolder(itm) {
            var hasChildren = itm.folders ? (itm.folders.length > 0 ? true : false) : false;
            var expanded = false;

            if (itm.listId)
                expanded = itm.templateFolderId == null ? true : false;
            else
                expanded = !itm.parentId ? true : false;

            return {
                id: itm.folderId,                
                parentId: itm.parentId,
                text: itm.name,
                expanded: expanded,
                hasChildren: hasChildren,
                docCount: 0,
                items: [],
                name: ko.observable(itm.name),
                isFavourite: ko.observable(false),
                folderId: itm.folderId,
                libraryId: itm.libraryId,
                folders: [],
                data: itm
            };
        }
});
